import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import {Breadcrumb} from 'antd';

const MetaBreadcrumb = (props) => {
  return (
    <Breadcrumb css={css`
      background-color: #B3E5FC;
      padding: 12px;
    `}>
        <Breadcrumb.Item>{props.label}</Breadcrumb.Item>
    </Breadcrumb>
  )
}

export default MetaBreadcrumb;